import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	resultLabel: {
		id: 'search-pull-request-result.label',
		defaultMessage: 'Pull request',
		description: 'Search pull request label',
	},
});
